module.exports = __webpack_public_path__ + "static/media/bebe4.1e6ec5e9.jpg";